import { render, staticRenderFns } from "./FrenteDeCaixaConcluidos.vue?vue&type=template&id=fe931764&scoped=true&"
import script from "./FrenteDeCaixaConcluidos.vue?vue&type=script&lang=js&"
export * from "./FrenteDeCaixaConcluidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe931764",
  null
  
)

export default component.exports